import { render, staticRenderFns } from "./UAMTable.vue?vue&type=template&id=1e3eb92a&scoped=true"
import script from "./UAMTable.vue?vue&type=script&lang=js"
export * from "./UAMTable.vue?vue&type=script&lang=js"
import style0 from "./UAMTable.vue?vue&type=style&index=0&id=1e3eb92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3eb92a",
  null
  
)

export default component.exports